import { Component, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { isEqual } from 'lodash-es';
export interface IAumMenuOptionsForRow {
    items: IAumMenuItemPerRow[];
}
export interface IAumMenuItemPerRow {
    interchangeable: boolean;
    caption?: string;
    action?: string;
    icon?: string;
    conditionalOptions?: {}[];
}

export interface IConditionalOptions {
    propertyKey: string;
    value: any;
    caption: string;
    icon?: string;
    disabled?: boolean;
}

export interface IAumMenuPerRowDelegate {
    onMenuItemPerRowClick(action: string, row: any, item?: IAumMenuItemPerRow, event?: Event): void;
}
@Component({
    selector: 'aum-menu-item-per-row',
    templateUrl: './aum-menu-item-per-row.component.html',
    styleUrls: ['./aum-menu-item-per-row.component.scss'],
})
export class AumMenuItemPerRowComponent {
    @Input() items: IAumMenuItemPerRow[];
    @Input() row: any;
    DELEGATE?: IAumMenuPerRowDelegate;
    @Input() public set delegate(delegate: IAumMenuPerRowDelegate) {
        if (delegate) {
            this.DELEGATE = delegate;
        }
    }

    multiOptionsItem: IAumMenuItemPerRow[];
    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
        //TODO, this should only be added on a global space
        this.addSvgIcon('aumico-pattern-icon-add-circle');
        this.addSvgIcon('aumico-pattern-icon-settings-vertical');
    }

    onClick(item: IAumMenuItemPerRow, event: Event) {
        if (this.DELEGATE) {
            this.DELEGATE.onMenuItemPerRowClick(item.action, this.row, item, event);
        }
    }
    checkArrayEquality(arrayOne: any[], arrayTwo: any[]) {
        return isEqual(arrayOne.sort(), arrayTwo.sort());
    }
    private addSvgIcon(name: string) {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
    get JSON(): JSON {
        return JSON;
    }

    get Array(): typeof Array {
        return Array;
    }
}
